import { tr as __tr, useLocale as __useLocale } from "../i18n/runtime";
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Mail, Lock, Eye, EyeOff, Plane } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../i18n/LanguageContext';
const Login = () => {
  __useLocale();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const {
    login
  } = useAuth();
  const {
    t,
    language
  } = useLanguage();
  const navigate = useNavigate();
  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login(email, password);
      if (user.role === 'admin' || user.role === 'staff') {
        navigate('/admin');
      } else {
        const next = new URLSearchParams(window.location.search).get('next');
        navigate(next?.startsWith('/checkout?') ? next : '/dashboard');
      }
    } catch (err) {
      setError(err.response?.data?.detail || t('common.error'));
    } finally {
      setLoading(false);
    }
  };
  return <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#6B5B95] via-[#5B4B85] to-[#4A3F75] px-4" dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center gap-2">
            <span className="text-4xl font-bold text-white">{__tr(t('brand'))}</span>
            <Plane className="w-8 h-8 text-[#FF8C42]" />
          </Link>
        </div>

        {/* Form Card */}
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <h2 className="text-2xl font-bold text-gray-800 text-center mb-6">
            {__tr(t('auth.loginTitle'))}
          </h2>

          {__tr(error && <div className="bg-red-50 text-red-600 px-4 py-3 rounded-lg mb-4 text-sm">
              {__tr(error)}
            </div>)}

          <form onSubmit={handleSubmit} className="space-y-5">
            {/* Email */}
            <div className="space-y-2">
              <label className="text-sm text-gray-600 flex items-center gap-2">
                <Mail className="w-4 h-4" />
                {__tr(t('auth.email'))}
              </label>
              <Input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="email@example.com" className="h-12 rounded-xl" required />
            </div>

            {/* Password */}
            <div className="space-y-2">
              <label className="text-sm text-gray-600 flex items-center gap-2">
                <Lock className="w-4 h-4" />
                {__tr(t('auth.password'))}
              </label>
              <div className="relative">
                <Input type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} placeholder="********" className="h-12 rounded-xl pl-10" required />
                <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
                  {__tr(showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />)}
                </button>
              </div>
            </div>

            {/* Submit */}
            <Button type="submit" disabled={loading} className="w-full h-12 bg-gradient-to-r from-[#6B5B95] to-[#5B4B85] hover:from-[#5B4B85] hover:to-[#4A3F75] text-white rounded-xl text-lg font-medium">
              {__tr(loading ? t('common.loading') : t('auth.loginBtn'))}
            </Button>
          </form>

          {/* Register Link */}
          <div className="text-center mt-6">
            <span className="text-gray-600">{__tr(t('auth.noAccount'))} </span>
            <Link to="/register" className="text-[#6B5B95] hover:underline font-medium">
              {__tr(t('nav.register'))}
            </Link>
          </div>
        </div>
      </div>
    </div>;
};
export default Login;
